module.exports = __webpack_public_path__ + "static/media/snooze.19eba692.svg";